import React from 'react';

export const Tag: React.FC<React.SVGProps<SVGSVGElement>> = ({ width, height, color }) => (
    <svg viewBox='0 0 50 50' width={width || '1em'} height={height || '1em'}>
        <path fill='none' d='M0 0h50v50H0z' />
        <circle cx='39' cy='11' r='3' fill='none' stroke={color || 'currentColor'} strokeLinecap='round' strokeMiterlimit='10' strokeWidth='3' />
        <path d='M47 5.5A2.5 2.5 0 0 0 44.5 3l-14.876.002c-1.33 0-2.603-.07-3.341.668L3.554 26.398a1.89 1.89 0 0 0 0 2.674l17.374 17.374a1.892 1.892 0 0 0 2.674 0L46.33 23.717c.738-.737.668-1.98.668-3.34L47 5.5z' fill='none' stroke={color || 'currentColor'} strokeLinecap='round' strokeMiterlimit='10' strokeWidth='3' />
    </svg>
);
